/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { VApplication } from '../../../../../application';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { ProvisionalDetailPageService } from '@pages/ProvisionalDetailPage/services';

const MODULE_NAME = 'profile.machines.states.getPage';
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.ProvisionalDetailPageService'
  ) as ProvisionalDetailPageService;
};

export const cancelPolicy = async (context: any, event: any) => {
  const currentState = 'CANCEL_POLICY';
  const method = 'cancelPolicy';

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent?.getCancelPolicyStatus(event?.payload);

      if (content) {
        return resolve({
          key: 'CANCEL_POLICY_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'CANCEL_POLICY_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'CANCEL_POLICY_ERROR',
        value: _msg,
      });
    }
  });
};
